export class PackageExportReadyMessage {
    public packageName: string;
    public url: string;

    constructor(packageName: string, url: string) {
        this.packageName = packageName;
        this.url = url;
    }
}